import styled from 'styled-components';
import {
  borderRadius,
  buttonStyle,
  space,
  fontSize,
  fontWeight,
  lineHeight,
  flexbox,
  width
} from 'styled-system';
import { colors } from '@styles/theme';

const LargeStateButton = styled('button')`
  appearance: button;
  cursor: pointer;
  border: 0;
  outline: 0;

  
  box-shadow: ${props =>
    !props.selected
      ? '0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 2px 8px 0px rgba(0, 0, 0, 0.05) '
      : '0px 8px 24px 0px rgba(0, 0, 0, 0.1), 0px 3px 6px 0px rgba(0, 0, 0, 0.1)'} ;

  background-color: ${props => (!props.selected ? 'white' : colors.green)};

  &:hover {
    box-shadow: 0px 12px 46px 0px rgba(0, 0, 0, 0.1), 0px 4px 8px 0px rgba(0, 0, 0, 0.1);
  }

  &:active {
    background-color: ${colors.lighterGray}; 
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 2px 8px 0px rgba(0, 0, 0, 0.05);
  }

  ${borderRadius}
  ${buttonStyle}
  ${space}
  ${width}  
  ${fontSize}
  ${fontWeight}
  ${lineHeight}
  ${flexbox}
`;

LargeStateButton.defaultProps = {
  borderRadius: 8,
  fontSize: 2,
  lineHeight: 1.29,
  fontWeight: 'normal',
  pl: 16,
  pr: 16,
  pt: 16,
  pb: 16
};

export default LargeStateButton;
